import { render, staticRenderFns } from "./advertisingList.vue?vue&type=template&id=65ae4e46&scoped=true&"
import script from "./advertisingList.vue?vue&type=script&lang=js&"
export * from "./advertisingList.vue?vue&type=script&lang=js&"
import style0 from "./advertisingList.vue?vue&type=style&index=0&id=65ae4e46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ae4e46",
  null
  
)

export default component.exports